import Awesomplete from 'awesomplete';
import debounce from 'lodash/debounce';

export default {
  init(inst) {
    this.instance = inst;
  },

  /**
   * Create the autocomplete
   *
   * @return {void}
   */
  buildAutocomplete() {
    const group = this.createFormElements();
    this.instance.$modal.getBody().prepend(group);
    this.input = group.querySelector('input');

    const debouncedSearch = debounce(this.search.bind(this), 300);

    this.input.addEventListener('keyup', (e) => {
      debouncedSearch(e.currentTarget.value);
    });

    this.awesomplete = new Awesomplete(this.input, {
      list: [],
      item: this.renderItem,
      filter: this.filterItems,
      replace: this.replaceText.bind(this),
    });
  },

  /**
   * Create required form fields for the autocomplete
   *
   * @return {DOMDivNode}
   */
  createFormElements() {
    const group = document.createElement('div');
    group.className = 'form-item';

    const label = document.createElement('label');
    label.setAttribute('for', 'modal-link-search');
    label.textContent = 'Zoeken';

    const input = document.createElement('input');
    input.type = 'search';
    input.id = 'model-link-search';
    input.className = 'form-control';

    group.appendChild(label);
    group.appendChild(input);

    return group;
  },

  /**
   * Render item
   *
   * @param  {object} text
   * @return {DOMLiNode}
   */
  renderItem(text) {
    const item = document.createElement('li');
    item.setAttribute('aria-selected', false);

    item.innerHTML = `
      ${text.value.title} - ${text.value.url}
    `;

    return item;
  },

  /**
   * Filter items returned from the API
   *
   * @return {boolean}
   */
  filterItems() {
    return true;
  },

  /**
   * Replace text in form and input field on autocomplete select
   *
   * @param  {object} text
   * @return {void}
   */
  replaceText(text) {
    this.input.value = `${text.value.title}`;

    this.instance.$form.setData({
      text: text.value.title,
      title: text.value.title,
      url: text.value.url,
      rel: typeof text.value.rel !== 'undefined' ? text.value.rel : '',
    });
  },

  /**
   * Call the autocomplete API
   *
   * @param  {string} val
   * @return {void}
   */
  search(val) {
    if (val.length < 3) {
      this.awesomplete.list = [];
      return;
    }

    window.axios.get(`${this.instance.opts.definedlinks}?search=${encodeURIComponent(val)}`)
      .then((res) => {
        this.awesomplete.list = res.data;
      });
  },
};
